import { createHybridCartApi } from "/npm/@brytdesigns/shopify-hybrid-cart-api@1.2.23";

/**
 * @internal
 */
const API = createHybridCartApi({ debug: window?.BrytDesigns?.debug });

export default API;
